import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';

import Case from '@pages/case';
import Error from '@pages/error';

import { withApollo } from '../graphql/apollo';
import { withTranslation, i18n } from '../i18n';

import caseQuery from '../graphql/queries/case.graphql';

const {
  publicRuntimeConfig: { ACTIVE_SITE_HANDLE }
} = getConfig();

const CasePage = ({ data, site }) =>
  data && data.entry ? <Case site={site} data={data} /> : <Error statusCode={404} site={site} />;

CasePage.getInitialProps = async ctx => {
  const {
    req,
    query: { slug },
    apolloClient
  } = ctx;

  const { language } = req || i18n;
  const site = `${ACTIVE_SITE_HANDLE}${language.toUpperCase()}`;

  const { data, error } = await apolloClient.query({
    query: caseQuery,
    variables: { site, slug }
  });

  if ((data && !data.entry) || error) {
    if (ctx.res) {
      ctx.res.statusCode = 404;
    }
  }

  return {
    namespacesRequired: ['common'],
    site,
    data,
    error
  };
};

CasePage.propTypes = {
  data: PropTypes.shape().isRequired,
  site: PropTypes.string.isRequired
};

CasePage.defaultProps = {};

export default withApollo(withTranslation('common')(CasePage));
